import { MenuItem, Paper, Stack, TextField, Typography } from "@mui/material";
import moment from "moment";
import Grid from "../../Tools/Grid";

export default function Learners({enrollments, loading, sessions, onAttach}){

    const titleOf = sessionId => sessions.find(s => s.id === sessionId)?.title || ''

    const columns = [
        {field: 'name', headerName: 'Apprenant', flex: 1, minWidth: 180},
        {field: 'email', headerName: 'Email', flex: 1, minWidth: 220},
        {
            field: 'createdAt',
            headerName: 'Inscrit le',
            width: 110,
            valueFormatter: ({value}) => value ? moment(value).format('DD/MM/YYYY') : ''
        },
        {
            field: 'sessionId',
            headerName: 'Session',
            width: 260,
            /** Sorting and filtering read the title, the cell itself edits the id */
            valueGetter: ({value}) => titleOf(value),
            renderCell: params =>
                <TextField
                    value={params.row.sessionId || ''}
                    onChange={event => onAttach(params.row.id, event.target.value)}
                    select
                    size='small'
                    variant='standard'
                    fullWidth
                    InputProps={{disableUnderline: true}}
                >
                    <MenuItem value=''>
                        <em>Aucune session</em>
                    </MenuItem>

                    {sessions.map(s =>
                        <MenuItem key={s.id} value={s.id}>{s.title}</MenuItem>
                    )}
                </TextField>
        }
    ]

    return <Paper variant='outlined' sx={{p: 2}}>

        <Stack spacing={2}>

            <Typography variant='subtitle2'>Apprenants inscrits</Typography>

            <Grid
                id='design-session-learners'
                columns={columns}
                rows={loading ? undefined : enrollments}
                toolbar
            />

        </Stack>

    </Paper>
}
